var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"you_section"},[_c('BottomBack',{attrs:{"borderStyle":{ transform: 'scaleX(1)', left: 0 }}},[_c('div',{staticClass:"main"},[_c('TodayData'),_c('OzoneMonitor'),_c('WarningInfo')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }